/* @ngInject */
const commandeFields = (
  commandeLabels,
  types,
  icons
) => {
  const self = {}

  self.id = {
    ref: 'id',
    label: commandeLabels.fields.id.text,
    icon: '',
    output: false,
  }


  self.name = {
    ref: 'name',
    label: commandeLabels.fields.name.text,
    icon: '',
    type: types.text(),
    required: true,
    unique: true,
    nature: 'commande',
    messages: commandeLabels.fields.name.messages,
    output: {
      sortable: true,
      table: { prefill: true, },
      details: true,
      excel: { prefill: false, },
    },
  }

  self.location = {
    ref: 'location',
    label: commandeLabels.fields.location.text,
    icon: '',
    type: types.text(),
    required: false,
    unique: false,
    nature: 'commande',
    messages: commandeLabels.fields.location.messages,
    output: {
      sortable: true,
      table: { prefill: true, },
      details: true,
      excel: { prefill: false, },
    },
  }

  self.wagonCount = {
    ref: 'wagonCount',
    label: commandeLabels.fields.wagonCount.text,
    icon: icons.commande.wagonCount,
    output: {
      sortable: true,
      table: { prefill: true, },
      excel: { prefill: true, },
      style: { overflow: true, },
    },
  }

  return self
}
export default commandeFields



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/commande/resources/fields.resource.js